<template>
  <b-row>
    <b-col md="4">
      <label>Divisa*</label>
    </b-col>
    <b-col md="8">
      <b-form-select v-model="oferta.divisaId" v-if="divisas.length > 1" :disabled="disabled">
        <b-form-select-option v-for="d in divisas" :key="d.id" :value="d.id">
          {{ d.nombre }} ({{ d.abreviatura }})
        </b-form-select-option>
      </b-form-select>
      <span v-else-if="divisa">
        <b-form-input readonly :value="divisa.abreviatura" />
      </span>
      <span v-else>
        <b-form-input readonly placeholder="Sin divisa asociada" />
      </span>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

export default {
  props: {
    disabled: Boolean,
  },
  computed: {
    ...mapState(useOfertaFormStore, ["oferta", "divisas", "divisa"]),
  },
};
</script>
